module.exports = __webpack_public_path__ + "img/dropdown-search.3513db11.png";